// 定义正则表达式黑名单
export const blacklistPatterns = [
  /^$/, // 空字符串
  /^\/$/, // 根路径
  /^\/\d+$/, // 以数字结尾的路径，如 /11, /123
  /^\d+$/, // 纯数字，如 123, 256
  /^\/[a-z]+$/, // 以小写字母组成的路径，如 /abc, /aaa
  /^\/s\d+t\d+$/, // 特定格式路径，如 /s2t1, /s3t3
  /^鎈.*$/, // 特殊字符开头的路径
  /^test$/, // 特定字符串
  // 添加其他规则...
];

// 检查路径是否在黑名单中
export function isBlacklisted(path) {
  return blacklistPatterns.some((pattern) => pattern.test(path));
}
